import centralEventBus from "~/lib/centralEventBus";

function clearStore(e) {
  centralEventBus.$emit("vuexPersistClearStorage");
}

export default function () {
  window.addEventListener("kea:logout", clearStore);
  window.addEventListener("redirectToOperatorPortal", clearStore);
  window.addEventListener("ciam:logout", clearStore);
}
